module.exports = __webpack_public_path__ + "img/earth.f6b77bcd.png";